import * as React from 'react';

import ProfileBoostIntro from './steps/intro/ProfileBoostIntro';
import ProfileBoostData from './steps/data/ProfileBoostData';
import ProfileBoostComplete from './steps/complete/ProfileBoostComplete';

import './profile-boost.scss';

import type { InfluencerProfileForm } from 'types';
import type {
  FieldDescriptionShowParams
} from 'modules/influencers/components/influencer-create-profile/InfluencerCreateProfile';

interface Props {
  activeStep: number,
  details: InfluencerProfileForm,
  onUpdate: (details: InfluencerProfileForm) => void,
  onSubmit: (details: InfluencerProfileForm) => void,
  onCancel: (details: InfluencerProfileForm) => void,
  onFieldDescriptionShow: (params: FieldDescriptionShowParams) => void,
  onFieldDescriptionHide: () => void
}

const ProfileBoost: React.FC<Props> = ({
  activeStep,
  details,
  onUpdate,
  onSubmit,
  onCancel,
  onFieldDescriptionShow,
  onFieldDescriptionHide
}): JSX.Element => {
  const renderIntro = (): React.ReactNode => (
    <div className="profile-boost__intro">
      <ProfileBoostIntro
        details={details}
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
    </div>
  );

  const renderData = (): React.ReactNode => (
    <div className="profile-boost__data">
      <ProfileBoostData
        details={details}
        onSubmit={onUpdate}
        onCancel={onCancel}
        onFieldDescriptionShow={onFieldDescriptionShow}
        onFieldDescriptionHide={onFieldDescriptionHide}
      />
    </div>
  );

  const renderComplete = (): React.ReactNode => (
    <ProfileBoostComplete />
  );

  return (
    <div className="profile-boost">
      {activeStep === 8 && renderIntro()}
      {activeStep === 9 && renderData()}
      {activeStep === 10 && renderComplete()}
    </div>
  );
};

export default ProfileBoost;
